import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { fontFamily } from '../../lib/font-family';
import { Logo } from '../shared/Logo';
import { Haniwa } from './Haniwa';

// NOTE: gameIdCodeはゲームの識別コード。お客様対応を行う時に用いる。
// see: https://ncl-guest.slack.com/archives/GNEQNL340/p1584433917314300
const gameIdCode = '9006';

export const ErrorScreenContent: React.FC<{ errorCode?: string }> = ({ errorCode }) => {
  const { t, i18n } = useTranslation('translation');
  const errorMessage = getText(t, errorCode || '3999');
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #f5f1e3;
        width: 100%;
        height: 100%;
        padding: 0 48px;
        font-family: ${fontFamily(i18n.language || 'en-US')};

        .image {
          width: 96px;
          height: 96px;
        }
        .logo {
          margin: 16px 0;
        }
        .message {
          font-size: 14px;
        }
        .code {
          font-size: 12px;
        }
        span {
          text-align: center;
          color: #938666;
        }
        span:nth-of-type(2) {
          margin: 40px 0 0;
        }
      `}
    >
      <div className="image">
        <Haniwa />
      </div>
      <div className="logo">
        <Logo />
      </div>
      <span className="message">{errorMessage}</span>
      {errorCode && (
        <span className="code">{`${t('error_code')}: ${gameIdCode}-${errorCode}`}</span>
      )}
    </div>
  );
};

// helper function
function getText(t: TFunction, errorCode?: string) {
  switch (errorCode) {
    case '4003':
    case '4103':
      return t('error_use_old_api');
    case '3990':
    case '3997':
      return t('error_under_maintenance');
    case '3998':
      return t('error_service_closed');
    case '3993':
    case '3994':
    case '3995':
    case '3996':
      return t('error_generic');
    case '2997':
    case '2998':
    case '2999':
    case '3992':
    case '3999':
    default:
      return t('error_unknown_status');
  }
}
